module.exports = __webpack_public_path__ + "static/media/caret-down.0571c403.svg";